// extracted by mini-css-extract-plugin
module.exports =  {"root":"_93444fe79c--root--suC1F"};